import React, { Fragment } from "react"

import { getOrdersTaxItems, thousandSeparator } from "utils"
import classes from "./OhTaxes.module.scss"

const OhTaxes = props => {
  const { order } = props

  const taxes = getOrdersTaxItems(order)

  return (
    <Fragment>
      {taxes.map(tax =>
        tax.amount !== 0 ?
          <div
            key={tax.title}
            className={classes["total-item"]}
          >
            <span>
              {tax.title}{" "}
              {tax.isPercentageModel ? `(%${tax.percentage})` : ""}
            </span>
            <span>{thousandSeparator(tax.amount)}</span>
          </div> :
          null
      )}
    </Fragment>
  )
}

export default OhTaxes